/* HYV — Back-in-stock requests (snippets/hyv-notify-me.liquid)

   Shows the request form only when the SELECTED variant is unavailable, and
   follows the swatch: pick a sold-out colour and the block appears naming that
   colour; pick one in stock and it disappears.

   Unlike the B2B gate, this one does NOT fail open. There, a network error must
   not stand between a buyer and the prices; here, the whole value of the
   interaction is that the address reaches us. Telling someone "we'll email you"
   when nothing was recorded is worse than telling them it failed. */
(function () {
  'use strict';
  var root = document.querySelector('[data-hyv-notify]');
  if (!root) return;

  var openBtn = root.querySelector('[data-hyv-notify-open]');
  var form = root.querySelector('[data-hyv-notify-form]');
  var msg = root.querySelector('[data-hyv-notify-msg]');
  var variantEl = root.querySelector('[data-hyv-notify-variant]');
  var endpoint = root.getAttribute('data-endpoint') || '';

  /** Variant data as Shopify prints it on the PDP, so availability is exact. The live Impact PDP
      prints no product JSON, so without a fallback the first swatch tap onto a sold-out colour hid
      this block (Oct 2026). Fetch /products/<handle>.js once instead. */
  var fetched = null;
  var productOptions = [];
  var altsEl = root.querySelector('[data-hyv-notify-alts]');
  var chipsEl = root.querySelector('[data-hyv-notify-chips]');

  /* In-stock alternatives for a sold-out selection: one chip per in-stock colour, which clicks the page's own
     colour swatch so Impact's variant change (price, gallery, buy box) runs exactly as a manual pick would. */
  function colourIndex() {
    for (var i = 0; i < productOptions.length; i++) {
      var n = (productOptions[i].name || productOptions[i] || '').toString().toLowerCase();
      if (n === 'color' || n === 'colour') return i + 1;
    }
    return productOptions.length ? 1 : 0;
  }
  function renderAlts(current) {
    if (!altsEl || !chipsEl) return;
    var idx = colourIndex();
    var variants = variantMap();
    var seen = {}, chips = [];
    for (var i = 0; i < variants.length && idx; i++) {
      var v = variants[i];
      var name = v['option' + idx];
      if (!v.available || !name || seen[name]) continue;
      // Only colours that match the current selection on every other option (size, lid) are true swaps.
      var same = true;
      for (var o = 1; o <= 3; o++) { if (o !== idx && current && v['option' + o] !== current['option' + o]) same = false; }
      if (!same) continue;
      seen[name] = true;
      var img = v.featured_image && v.featured_image.src ? v.featured_image.src : '';
      if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
      chips.push('<button type="button" class="hyv-notify__chip" data-colour="' + name.replace(/"/g, '&quot;') + '">' +
        (img ? '<img src="' + img + '" alt="" width="34" height="34" loading="lazy">' : '') + '<span>' + name + '</span></button>');
    }
    chipsEl.innerHTML = chips.slice(0, 8).join('');
    altsEl.hidden = chips.length === 0;
  }
  if (chipsEl) chipsEl.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.hyv-notify__chip');
    if (!chip) return;
    var want = chip.getAttribute('data-colour').toLowerCase();
    var radios = document.querySelectorAll('.shopify-section--main-product input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      var label = (r.labels && r.labels[0] ? r.labels[0].textContent : r.value || '').trim().toLowerCase();
      if (label === want || r.value.toLowerCase() === want) { r.click(); return; }
    }
  });
  function variantMap() {
    var el = document.querySelector('[type="application/json"][data-product-json], script.product-json');
    if (el) { try { return JSON.parse(el.textContent).variants || []; } catch (e) {} }
    return fetched || [];
  }
  (function prefetch() {
    if (document.querySelector('[type="application/json"][data-product-json], script.product-json')) return;
    var url = (root.getAttribute('data-product-url') || location.pathname).split('?')[0].replace(/\/$/, '');
    fetch(url + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && p.variants) { fetched = p.variants; productOptions = p.options || []; sync(); } })
      .catch(function () {});
  })();

  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? parseInt(input.value, 10) : parseInt(root.getAttribute('data-variant-id'), 10);
  }

  function sync() {
    var id = currentVariantId();
    var variants = variantMap();
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) { v = variants[i]; break; }
    }

    // No variant JSON on the page (theme variation): fall back to the server's
    // opinion, which is correct on first paint and stale only after a swatch
    // change — better than guessing "available" and hiding the form.
    var soldOut = v ? v.available === false : root.hasAttribute('data-out-of-stock');
    // Paid add-ons (Add a name, kit rows, Build your own) cannot be bought with a sold-out colour; hide them while one is selected.
    document.documentElement.classList.toggle('hyv-variant-soldout', soldOut);
    root.hidden = !soldOut;
    if (!soldOut) { collapse(); return; }

    renderAlts(v);
    var title = v ? v.title : root.getAttribute('data-variant');
    if (variantEl && title) variantEl.textContent = title;
    root.setAttribute('data-variant', title || '');
    root.setAttribute('data-variant-id', String(id || ''));
  }

  function collapse() {
    if (form) form.hidden = true;
    if (openBtn) openBtn.hidden = false;
    if (msg) { msg.hidden = true; msg.className = 'hyv-notify__msg'; }
  }

  if (openBtn) openBtn.addEventListener('click', function () {
    openBtn.hidden = true;
    form.hidden = false;
    var input = form.querySelector('input[name=email]');
    if (input) input.focus();
  });

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('input[name=email]');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      show('warn', 'That email doesn’t look right.');
      input.focus();
      return;
    }

    var btn = form.querySelector('.hyv-notify__submit');
    if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }

    var payload = {
      action: 'notify_me',
      email: email,
      product: root.getAttribute('data-product'),
      variant: root.getAttribute('data-variant'),
      variant_id: root.getAttribute('data-variant-id'),
      url: root.getAttribute('data-product-url'),
      submitted_at: new Date().toISOString()
    };

    var done = function (ok) {
      if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; }
      if (ok) {
        form.hidden = true;
        if (openBtn) {
          openBtn.hidden = false;
          var label = openBtn.querySelector('[data-hyv-notify-label]');
          if (label) label.textContent = 'We’ll email you when it’s back';
          openBtn.disabled = true;
        }
        show('ok', 'Saved. We’ll email you the moment it’s back — nothing else.');
        msg.hidden = false;
      } else {
        show('warn', 'We couldn’t save that just now. Please message us and we’ll add you by hand.');
      }
    };

    if (!endpoint) { done(false); return; }
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
      keepalive: true
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r; })
      .then(function () { done(true); })
      .catch(function () { done(false); });
  });

  function show(kind, text) {
    if (!msg) return;
    msg.className = 'hyv-notify__msg hyv-notify__msg--' + kind;
    msg.textContent = text;
    msg.hidden = false;
  }

  sync();
  // Impact's variant:change carries the variant itself, which is exact even before the fetch lands
  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (v && typeof v.available === 'boolean' && fetched === null && !document.querySelector('script.product-json')) {
      fetched = [{ id: v.id, title: v.title, available: v.available }];
    }
    setTimeout(sync, 0);
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') sync();
  }, true);
})();
